// ── Lliuq local session history ──────────────────────────────────────────────
// Saves to localStorage only. Nothing leaves the device.

const KEY = "lliuq_history";
const SESSION_KEY = "lliuq_sessions";
const MAX = 50;

// Save a history entry (shown in Home recent activity)
export function saveSession({ tool, title, subtitle, id }) {
  try {
    const existing = JSON.parse(localStorage.getItem(KEY) || "[]");
    const record = { tool, title, subtitle, ts: Date.now(), id: id || Date.now().toString() };
    const updated = [record, ...existing].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(updated));
  } catch {}
}

// Save full session data (for restore on click)
export function saveFullSession(id, data) {
  try {
    const existing = JSON.parse(localStorage.getItem(SESSION_KEY) || "{}");
    existing[id] = { ...data, savedAt: Date.now() };
    // Keep only last 20 full sessions to avoid storage bloat
    const keys = Object.keys(existing).sort((a, b) => (existing[b].savedAt || 0) - (existing[a].savedAt || 0));
    const trimmed = {};
    keys.slice(0, 20).forEach(k => { trimmed[k] = existing[k]; });
    localStorage.setItem(SESSION_KEY, JSON.stringify(trimmed));
  } catch {}
}

// Load full session data by id
export function loadSession(id) {
  try {
    const all = JSON.parse(localStorage.getItem(SESSION_KEY) || "{}");
    return all[id] || null;
  } catch { return null; }
}

export function getHistory() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch { return []; }
}

export function clearHistory() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(SESSION_KEY);
}

// Shared API key — one key for all tools
export function getGroqKey() {
  return localStorage.getItem("lliuq_groq_key") ||
    localStorage.getItem("scribe_key_v3") ||
    sessionStorage.getItem("groq_key") || "";
}

export function saveGroqKey(key) {
  localStorage.setItem("lliuq_groq_key", key);
  localStorage.setItem("scribe_key_v3", key); // keep backward compat
  sessionStorage.setItem("groq_key", key);
}

export function clearGroqKey() {
  const keys = [ "lliuq_groq_key", "scribe_key_v3", "scribe_key_v2", "scribe_key", "groq_key", "interview_key", "sop_key", "groq_api_key", "lliuq_key" ];
  keys.forEach(k => { localStorage.removeItem(k); sessionStorage.removeItem(k); });
}